import {lazy, Suspense} from "react";
import CircularLoader from "../../../customs/loader/main";


const Main = lazy(() => import("../../../components/application/corporateProfileUpdate/changeOfOfficer/main"));

const CorporateProfileUpdateChangeOfOfficer = () => {

    return(

        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>
      
    )
};

export default CorporateProfileUpdateChangeOfOfficer;